import { useQuery } from "@tanstack/react-query";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { LoadingState } from "@/components/ui/loading-state";

const formatCurrency = (value: number) => {
  const isNegative = value < 0;
  const absoluteValue = Math.abs(value);
  const formattedValue = absoluteValue.toLocaleString();
  
  if (isNegative) {
    return <span className="text-red-500">({`$${formattedValue}`})</span>;
  }
  return <span className="text-green-500">${formattedValue}</span>;
};

export const ProjectionsTable = () => {
  const {
    data: projections,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["financial-projections"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("financial_projections")
        .select("*")
        .order("year", { ascending: true });

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) return <LoadingState />;
  if (error) return <div>Error loading projections</div>;
  if (!projections?.length) return <div>No projections available</div>;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl text-primary">
          Financial Projections
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Year</TableHead>
              <TableHead>Revenue</TableHead>
              <TableHead>Expenses</TableHead>
              <TableHead>Net Profit</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {projections.map((row) => (
              <TableRow key={row.id}>
                <TableCell className="font-medium">{row.year}</TableCell>
                <TableCell>${row.revenue.toLocaleString()}</TableCell>
                <TableCell>${row.expenses.toLocaleString()}</TableCell>
                <TableCell>{formatCurrency(row.profit)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};